var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav-menu"}},[_c('ul',_vm._l((_vm.menuItems),function(item){return _c('li',{key:item.name,class:{
        active: item.active,
        'has-sub-items': _vm.navHasSubItems(item)
      },on:{"click":function () { return _vm.navigate(item); }}},[_c('div',{staticClass:"menu-wrapper"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":item.icon}}),_c('span',[_vm._v(_vm._s(_vm.$t(item.name)))]),(_vm.navHasSubItems(item))?_c('font-awesome-icon',{staticClass:"sub-indicator",class:{ active: item.isExpanded },attrs:{"icon":_vm.faChevronDown}}):_vm._e()],1),(_vm.navHasSubItems(item))?_c('ul',{staticClass:"sub-menu",class:{
          active: item.isExpanded,
          'has-one': (item.subItems.length === 1),
          'has-two': (item.subItems.length === 2),
          'has-three': (item.subItems.length === 3),
          'has-four': (item.subItems.length === 4)
        }},_vm._l((item.subItems),function(sub){return _c('li',{key:sub.name,class:{ active: sub.active },on:{"click":function (e) {
            e.stopPropagation();
            _vm.navigate(sub);
          }}},[_c('span',[_vm._v(_vm._s(_vm.$t(sub.name)))])])}),0):_vm._e()])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }